import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { windowText } from "../components/Countdown";
import { money, customText } from "../lib/api";

export default function OrderConfirmation() {
  const { state } = useLocation();
  const order = state?.order;
  if (!order) return <Navigate to="/" replace />;

  return (
    <div className="max-w-2xl mx-auto px-6 py-16 text-center">
      <CheckCircle2 className="h-16 w-16 text-emerald-400 mx-auto" />
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-6">Order Confirmed</h1>
      <p className="text-zinc-400 mt-2">Thank you for supporting the team. Your preorder has been received.</p>

      <div className="bg-[#121216] border border-white/10 rounded-lg p-6 mt-8 text-left">
        <div className="flex justify-between items-center border-b border-white/10 pb-3 mb-3">
          <span className="font-mono text-sm text-zinc-500">Order Number</span>
          <span data-testid="confirmation-order-number" className="font-mono font-bold text-yellow-400 text-lg">{order.order_number}</span>
        </div>
        <div className="flex justify-between text-sm text-zinc-300 mb-1"><span>Academy</span><span>{order.academy_name || "—"}</span></div>
        <div className="flex justify-between text-sm text-zinc-300 mb-1"><span>Status</span><span className="text-emerald-400">{order.status}</span></div>
        <div className="flex justify-between text-sm text-zinc-300 mb-1"><span>Units</span><span className="font-mono">{order.units}</span></div>
        <div data-testid="confirmation-items" className="border-t border-white/10 mt-3 pt-3 space-y-2">
          {(order.items || []).flatMap((it) => it.sizes.map((s) => (
            <div key={`${it.product_id}-${it.colorway}-${s.size}-${customText(it.customization)}`} className="flex justify-between text-sm text-zinc-300">
              <span>{s.qty}× {it.product_name}<span className="block text-xs text-zinc-500">{it.color ? `${it.color} · ` : ""}Size {s.size} · {money(s.unit_price)} ea{customText(it.customization) && <span className="block text-yellow-400">{customText(it.customization)}</span>}</span></span>
              <span className="font-mono">{money(s.unit_price * s.qty)}</span>
            </div>
          )))}
        </div>
        <div className="border-t border-white/10 mt-3 pt-3 space-y-1 text-sm text-zinc-300">
          <div className="flex justify-between"><span>Subtotal</span><span className="font-mono">{money(order.subtotal)}</span></div>
          <div className="flex justify-between"><span>Shipping</span><span className="font-mono">{money(order.shipping)}</span></div>
          {order.tax > 0 && <div className="flex justify-between"><span>Sales tax ({order.tax_rate}%)</span><span data-testid="confirmation-tax" className="font-mono">{money(order.tax)}</span></div>}
        </div>
        <div className="flex justify-between font-bold text-white mt-2"><span>Total</span><span data-testid="confirmation-total" className="font-mono text-yellow-400">{money(order.total)}</span></div>
        {order.shipping_address?.line1 && (
          <p className="text-xs text-zinc-500 mt-3">Ships to: {[order.shipping_address.line1, order.shipping_address.city, order.shipping_address.state, order.shipping_address.zip].filter(Boolean).join(", ")}</p>
        )}
      </div>

      <div className="bg-yellow-400/10 border border-yellow-400/30 rounded-lg p-4 mt-4 text-sm font-mono text-yellow-300">
        ● Paragon Winter '26 · Made to order — production begins after the order window closes · {windowText()}
      </div>

      <div className="flex gap-3 justify-center mt-8">
        <Link to="/shop" className="btn-primary px-6 py-3 rounded-sm">Keep Shopping</Link>
      </div>
    </div>
  );
}
